import { io } from 'socket.io-client'

export const chatSocket = io(`${process.env.REACT_APP_FF_API_ROOT}/chat`, {
  withCredentials: true,
  transports: ['websocket'],
  query: { isSupport: 'true' },
})
